// Dynamic styles based on theme - to be used with useThemedStyles.
// Shared by the documents screen and its upload form.
export const createMyDocumentsStyles = ({ ui: { colors, type, space } }) => ({
	inlineLoading: {
		paddingVertical: space.lg,
		alignItems: 'center',
	},
	section: {
		gap: space.sm,
	},
	itemRow: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.md,
	},
	itemContent: {
		flex: 1,
		gap: space.xs,
	},
	rowTitle: {
		...type.rowTitleSemibold,
		color: colors.text,
	},
	rowMeta: {
		...type.secondary,
		color: colors.textSecondary,
		marginTop: space.xxs,
	},
	statusTag: {
		marginTop: space.sm,
	},
	mutedText: {
		...type.bodySmall,
		color: colors.textSecondary,
	},
	uploadButton: {
		alignSelf: 'flex-start',
		marginTop: space.sm,
	},
	uploadForm: {
		borderTopWidth: 1,
		borderTopColor: colors.border,
		marginTop: space.md,
		paddingTop: space.xs,
	},
	formTitle: {
		...type.rowTitleSemibold,
		color: colors.text,
	},
	formField: {
		marginTop: space.md,
	},
	formLabel: {
		...type.fieldLabel,
		color: colors.text,
		marginBottom: space.xs,
	},
	fileButtons: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: space.sm,
	},
	fileGuidance: {
		...type.caption,
		color: colors.textFaint,
		marginTop: space.md,
	},
	formButtons: {
		flexDirection: 'row',
		gap: space.sm,
		marginTop: space.md,
	},
	formButton: {
		flex: 1,
	},
	fileNameRow: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: space.xs,
		marginBottom: space.sm,
	},
	fileName: {
		...type.secondary,
		color: colors.text,
		flexShrink: 1,
	},
});
